import { useLazyQuery } from "@apollo/client";
import {
  GET_VENDORS,
  GET_UPDATED_RS_VENDORS_QUERY,
} from "../../graphql/queries/vendors/vendors.queries";
import { useState } from "react";

const useVendors = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [getVendorsQuery] = useLazyQuery(GET_VENDORS);
  const [getUpdatedRSVendorsQuery] = useLazyQuery(
    GET_UPDATED_RS_VENDORS_QUERY,
    { fetchPolicy: "network-only" }
  );

  const getVendors = async () => {
    const { data, error } = await getVendorsQuery();
    if (error) {
      console.error(error);
    }
    if (data?.vendors?.length) {
      const getSortedVendors = (data) => {
        const dataCopy = [...data];
        return dataCopy.sort((a, b) => a?.name.localeCompare(b?.name)) || [];
      };
      setVendors(getSortedVendors(data.vendors));
    }
  };

  const updateVendorsFromRS = async () => {
    setIsLoading(true);
    const { data, error } = await getUpdatedRSVendorsQuery();
    if (error) {
      console.error(error);
    }
    if (data?.fetchRSVendors?.length) {
      const getSortedVendors = (data) => {
        const dataCopy = [...data];
        return dataCopy.sort((a, b) => a?.name.localeCompare(b?.name)) || [];
      };
      setVendors(getSortedVendors(data.fetchRSVendors));
    }
    setIsLoading(false);
  };

  return { vendors, setVendors, getVendors, updateVendorsFromRS, isLoading };
};

export default useVendors;
